import {load} from "recaptcha-v3";

class GgCaptcha {

    static ggCaptchaKey = '6LdDdSgeAAAAACf-DDG6Blt6XQRfqgp9kZG2jETa'; //SITE KEY

    static createGGToken(callback) {
        load(GgCaptcha.ggCaptchaKey).then((recaptcha) => {
            recaptcha.execute('contact').then((token) => {
                callback(token);
            });
        });
    }
}

export default GgCaptcha